import { delay } from '@/utils';

export async function waitForResourceCondition(
	fetchFn,
	compareFn,
	retries = 4,
	delayTime = 2000
) {
	try {
		const response = await fetchFn();

		if (!compareFn(response) && retries > 0) {
			await delay(delayTime);

			return waitForResourceCondition(
				fetchFn,
				compareFn,
				retries - 1,
				delayTime
			);
		}

		return response;
	} catch (error) {
		if (retries > 0) {
			await delay(delayTime);

			return waitForResourceCondition(
				fetchFn,
				compareFn,
				retries - 1,
				delayTime
			);
		}
		throw error;
	}
}

// https://github.com/Adyen/adyen-web/tree/main/packages/server/translations
const LOCALE_OVERRIDES = {
	ar: 'ar',
	bn: 'bn-IN',
	zh: 'zh-CN',
	sr: 'sr-Cyrl-RS',
	nb: 'no-NO'
};

export function getFullLocale(lang) {
	if (LOCALE_OVERRIDES[lang]) {
		return LOCALE_OVERRIDES[lang];
	}

	const locale = new Intl.Locale(lang).maximize();

	return `${locale.language}-${locale.region}`;
}
